export default __webpack_public_path__ + "static/media/agrosemesumo2.da561236.jpg";